import { render, staticRenderFns } from "./TrainingParticipantList.vue?vue&type=template&id=e24b76b8"
import script from "./TrainingParticipantList.vue?vue&type=script&lang=js"
export * from "./TrainingParticipantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports